const BASE_URL = process.env.NODE_ENV === "development" ? "" : "https://brennholzbearbeitung.hessen-forst.org";

export default BASE_URL;